import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { BROWSER_COOKIES } from '@finder/shared/constants/app.constants';
import { SsrService } from '@finder/shared/services/ssr/ssr.service';

@Injectable()
export class SsrTokensInterceptor implements HttpInterceptor {
    private browserCookies = inject(BROWSER_COOKIES, { optional: true });
    private injector = inject(Injector);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const ssrService = this.injector.get(SsrService);

        /**
         * @SSR: `withCredentials` should only be used when the page is built in the browser. This property will
         * stop the page from being cached.
         * https://github.com/angular/angular/blob/v20.3.27/packages/common/http/src/transfer_cache.ts#L292
         *
         * Things that don't work
         * HTTP_TRANSFER_CACHE_ORIGIN_MAP
         * this is for mapping different internal network to external networks (lowers vs prod)
         *
         * includeRequestsWithAuthHeaders
         * https://v20.angular.dev/guide/ssr#includerequestswithauthheaders
         * there are no headers that pass along cookies when developing locally
         */
        if (ssrService.isBrowser()) {
            // I know you want to turn this into a conditional but don't. It's easier to read this way
            // let's clone the request with the credentials prop and overload it if we're in SSR
            let newReq = req.clone({ withCredentials: true});

            // we're in SSR mode so return the unaltered request obj
            if (ssrService.isDataFromTheServer()) {
                newReq = req;
            }

            return next.handle(newReq);
        }

        req = req.clone({
            setHeaders: {
                'X-Disney-Browser-Cookies': JSON.stringify(this.browserCookies, null, 0)
            },
        });

        return next.handle(req);
    }
}
